import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import { titleCaseToSnake } from '@/core';

type Variables = {
  address: string;
  zipcode: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
  pickupInstructions?: string;
  dropoffInstructions?: string;
  timeZone?: string;
  garageOpenHour?: string;
  garageCloseHour?: string;
  streetNumber?: string;
  streetName?: string;
  addressLine2?: string;
  county?: string;
  country?: string;
};
export type CreateLocationResponse = {
  data: {
    id: number;
  };
};

export const useCreateLocation = createMutation<
  CreateLocationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/rental_locations',
      method: 'POST',
      data: {
        address: variables.address,
        zipcode: variables.zipcode,
        city: variables.city,
        location_state: titleCaseToSnake(variables.state),
        latitude: variables.latitude,
        longitude: variables.longitude,
        pickup_instructions: variables.pickupInstructions,
        dropoff_instructions: variables.dropoffInstructions,
        time_zone: variables.timeZone,
        garage_open_hour: variables.garageOpenHour,
        garage_close_hour: variables.garageCloseHour,
        street_number: variables.streetNumber,
        street_name: variables.streetName,
        address_line_2: variables.addressLine2,
        county: variables.county,
        country: variables.country,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        const errors = err.response?.data?.errors;
        throw new Error(
          Array.isArray(errors)
            ? errors.join(', ')
            : 'Failed to create location'
        );
      }),
});
